
import styled from 'styled-components';

export const ComponentWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  position: relative
`;

export const TableBackground = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
`;

export const TableWrapper = styled.div`
  position: absolute;
  top: 40px;
  right: 20px;
  background-color: white;
  box-shadow: 5px 5px 20px -5px #d8d8d8;
  border-radius: 3px;
  border: 1px solid #d8d8d8;
  overflow: hidden;
  text-align: center;
  z-index: 6;

  .ReactTable .rt-th {
    display: flex;
    background-color: #C50019;
    color: white;
    align-items: center;
    justify-content: center;
  }
`;
